import DataFile from "@assets/lotties/curve-lower-1.json"
import Lottie, { LottieRefCurrentProps } from "lottie-react"
import React, { useEffect, useRef } from "react"

export const LowerLineLottie = ({
	isStopped,
	z,
	onFinished,
}: {
	isStopped: boolean
	z?: number
	onFinished?: () => void
}) => {
	const lottieRef = useRef<LottieRefCurrentProps>(null)

	const lottieStyle: React.CSSProperties = {
		position: "absolute",
		left: "0px", //"41px",
		bottom: "61px",
		zIndex: z ?? 3,
		width: "100%",
		height: "auto",
	}

	useEffect(() => {
		if (!isStopped && lottieRef.current) {
			lottieRef.current.play()
		}
	}, [isStopped, lottieRef])

	return (
		<Lottie
			lottieRef={lottieRef}
			animationData={DataFile}
			renderer={"svg"}
			loop={false}
			autoplay={false}
			rendererSettings={{
				preserveAspectRatio: "none slice",
			}}
			onComplete={onFinished}
			style={lottieStyle}
		/>
	)
}
